// extracted by mini-css-extract-plugin
module.exports = {"Intro":"Intro_Intro__fV5gp","topRow":"Intro_topRow__3mXhK","avatar":"Intro_avatar__1auD3","text":"Intro_text__12e0E"};